<template>
  <div class="text text-privacy" id="skipTo">
    <div v-html="getTextPrivacy"></div>
    <router-link :to="{ name: 'chapter'}">zurück zur Check-App</router-link>
  </div>
</template>

<!-- eslint-disable vue/multi-word-component-names -->
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'privacy',

  computed: {
    ...mapGetters([
      'getTextPrivacy'
    ]),
  }
}
</script>